require('./src/main')